module.exports = __webpack_public_path__ + "img/container-no-image.f04e0bad.jpg";